import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import Header from './Header';
import { treeStore } from 'store/mobx/tree.store';
import PackSamples from './PackSamples';
import TableSamples from './TableSamples';
import { storageStore } from 'store/mobx/storage.store';

export const ExtendedSampleContext = React.createContext('extended-sample-context');

export const Samples = observer((props) => {
  const { mode } = props;
  const { selectedNode } = treeStore;
  const { getSamples } = storageStore;

  useEffect(() => {
    loadSamples();
  }, [selectedNode]);

  const loadSamples = async () => {
    await getSamples({
      id: selectedNode.id,
      type: selectedNode.entity,
      withoutUserTable: selectedNode.entity === 'storage_pack',
    });
  };

  return (
    <div
      style={{
        overflow: 'hidden',
        height: '100%',
        maxHeight: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Header pack={selectedNode} />
      <div
        style={{
          flex: '1',
          overflow: 'auto',
          display: 'flex',
        }}
      >
        {selectedNode?.entity === 'storage_pack' ? (
          <PackSamples mode={mode} storageId={selectedNode.id_storage} pack={selectedNode} />
        ) : (
          <TableSamples mode={mode} />
        )}
      </div>
    </div>
  );
});

export default Samples;
